import React, { useContext } from 'react'
import VehicleNote from '../1_Vehicle/VehicleNote/VehicleNote'
import ValidationModal from 'components/ValidationModal'
import RemovableVehicles from '../1_Vehicle/RemoveVehicleBody/1_RemovableVehicles/RemovableVehicles'
import RequestedRemovalQuestions from '../1_Vehicle/RemoveVehicleBody/2_RequestedRemovalQuestions/RequestedRemovalQuestions'
import VehicleDA from '../1_Vehicle/AddVehicleBody/6_DriverAssignment/VehicleDA_Main'
import { ReplaceVehicleContext } from '../ReplaceVehicleContext/ReplaceVehicleContext'
import { NewDelete_VehicleContext, NewDelete_VehicleContextComp } from '../ReplaceVehicleContext/NewDelete_VehicleContext'
import RequestedCoverageEffDate from '../1_Vehicle/AddVehicleBody/1_RequestedCoverageEffDate/RequestedCoverageEffDate'
import BodyVIN from '../1_Vehicle/AddVehicleBody/2_BodyVIN/BodyVIN'
import VehicleInfo from '../1_Vehicle/AddVehicleBody/3_VehicleInfo/VehicleInfo'
import VehiclePurchased from '../1_Vehicle/AddVehicleBody/4_VehiclePurchased/VehiclePurchased'
import EndorsementVehicleOwned from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/EndorsementVehicleOwned'
import EndorsementVehicleLeasedFinanced from '../1_Vehicle/AddVehicleBody/5_VehicleLeasedFinanced/EndorsementVehicleLeasedFinanced'
import ReplaceVehicleBtnNav from '../1_Vehicle/ReplaceVehicleBtnNav/ReplaceVehicleBtnNav'
import { storageData } from 'services/Services'

const ReplaceVehicleMain = () => {
    const replaceVehicleContext = useContext(ReplaceVehicleContext)
    
    try {
        var removedVehicles = replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.removedVehicles
        var newVehicles = replaceVehicleContext.replaceVehicleClass.vehicles.vehiclesOnPolicy.newVehicles
        } catch (error) {
            var removeVehClass = JSON.parse(storageData.getItem("RemoveVehicleClass"))
            if(removeVehClass?.requestType == "Remove Vehicle"){
                const { deleteStatus, ...rest } = removeVehClass;
                const updatedRemoveVehicleClass = {
                    ...rest,
                    requestType: "Replace Vehicle",
                    vehicles: {
                        ...rest.vehicles,
                        vehiclesOnPolicy: {
                            ...rest.vehicles.vehiclesOnPolicy,
                            removedVehicles: [],
                            newVehicles: [],
                            pendingNewVehicles: [],
                            pendingRemovedVehicles: []
                        }
                    }
                };
                storageData.setItem("ReplaceVehicleClass", JSON.stringify(updatedRemoveVehicleClass));
                storageData.removeItem("RemoveVehicleClass");
                const userData = JSON.parse(storageData.getItem("userData"));
                delete userData["disclosureModal"];
                storageData.setItem("userData", JSON.stringify(userData));
                window.location.replace("/endorsement/replace-vehicle")
                return;
            }
        }

    return (
        <>
            <NewDelete_VehicleContextComp>
                <span className='px-md-5'>

                    {!(["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) &&
                        <>
                            <div className='mx-4'>
                                <h5 className='text-primary text-center fw-bold mb-4'>REPLACE VEHICLE</h5>
                                <RemovableVehicles requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementType={"ReplaceVehicle"} />
                            </div>

                            {/* Display removal questions when vehicle selected */}
                            {replaceVehicleContext?.replaceVehicleClass?.vehicles?.vehiclesOnPolicy?.removedVehicles.length > 0 &&
                                <>
                                    <div className='mx-4'>
                                        <RequestedRemovalQuestions requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementType={"ReplaceVehicle"} />
                                    </div>

                                    <hr />
                                    <h5 className='text-primary text-center fw-bold mb-4'>Add Vehicle</h5>
                                    {(newVehicles?.length < 1 || newVehicles[0]?.componentTracker != "VehicleDriverAssignment") &&
                                        <RequestedCoverageEffDate requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} />
                                    }
                                    {(newVehicles?.length < 1 || newVehicles[0].componentTracker == "VinInput") &&
                                        <BodyVIN requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementClassStr={"replaceVehicleClass"} endorsementSetClassStr={"setReplaceVehicleClass"} />
                                    }
                                    {newVehicles?.length > 0 && (["VehicleInfo", "VehiclePurchased", "VehicleOwned", "VehicleLeased", "VehicleFinanced"].includes(newVehicles[0]?.componentTracker)) &&
                                        <VehicleInfo requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementClassStr={"replaceVehicleClass"} endorsementSetClassStr={"setReplaceVehicleClass"} />
                                    }
                                    {newVehicles?.length > 0 && (["VehicleOwned", "VehiclePurchased", "VehicleLeased", "VehicleFinanced"].includes(newVehicles[0]?.componentTracker)) &&
                                        <VehiclePurchased requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementClassStr={"replaceVehicleClass"} endorsementSetClassStr={"setReplaceVehicleClass"} />
                                    }
                                    {newVehicles?.length > 0 && (["VehicleOwned"].includes(newVehicles[0]?.componentTracker)) &&
                                        <>
                                            <EndorsementVehicleOwned policyStateAbbr={replaceVehicleContext.getStateAbbr(replaceVehicleContext.replaceVehicleClass.policyState)}
                                                requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementClassStr={"replaceVehicleClass"}
                                            />
                                        </>
                                    }
                                    {newVehicles?.length > 0 && (["VehicleLeased", "VehicleFinanced"].includes(newVehicles[0]?.componentTracker)) &&
                                        <EndorsementVehicleLeasedFinanced policyStateAbbr={replaceVehicleContext.getStateAbbr(replaceVehicleContext.replaceVehicleClass.policyState)}
                                            requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementClassStr={"replaceVehicleClass"}
                                        />
                                    }
                                </>
                            }
                        </>
                    }

                    {removedVehicles?.length > 0 && (["VehicleDriverAssignment"].includes(removedVehicles[0]?.componentTracker)) &&
                        <VehicleDA requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} endorsementType={"ReplaceVehicle"} />
                    }
                    <hr />
                    <VehicleNote />
                </span>
                <hr />
                <ReplaceVehicleBtnNav />
            </NewDelete_VehicleContextComp>

            <ValidationModal
                title={replaceVehicleContext.validationTitle}
                show={replaceVehicleContext.showModal}
                handleClose={() => replaceVehicleContext.setShowModal(false)}
                validationMsg={replaceVehicleContext.validationMsg}
            />
        </>
    )
}

export default ReplaceVehicleMain